define.alias("shared/helpers/linkify-text", "settings/helpers/linkify-text");